export const API = process.env.REACT_APP_API_URL || "http://localhost:8000";

// ── API helpers ────────────────────────────────────────────────────────────────
export async function apiFetch(path, token, options = {}) {
  const res = await fetch(API + path, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { "x-license-token": token } : {}),
      ...options.headers,
    },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
  return res.json();
}

export default apiFetch;
